<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="user-tie" />
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <b-tabs>
      <b-tab :title="$t('profile')">
        <k-y-c-list></k-y-c-list>
      </b-tab>
      <b-tab :title="$t('contract')">
        <contract-list></contract-list>
      </b-tab>
    </b-tabs>
  </main>
</template>

<script>
import KYCList from './KYCList';
import ContractList from "./ContractList.vue";
export default {
  components: {ContractList, KYCList},
  i18n: {
    messages: {
      en: {
        title: "Client profile",
        profile: "Profile",
        contract: "Contract",
      },
      vi: {
        title: "Hồ sơ khách hàng",
        profile: "Hồ sơ",
        contract: "Hợp đồng",
      }
    }
  }
}
</script>